import React, { useEffect, useState } from 'react'
import CampaignTable from './CampaignTable'
import Pagination from '../Pagination';

import { Search, X } from 'lucide-react';
import useDebounce from '../../../utills/debounce';
import axios from 'axios';
import { encodeId } from '../../../utills/idUtils';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

const API_URL = process.env.REACT_APP_API_URL;

const Campaign_Overview_Section = () => {

    const navigate = useNavigate()
  const { dispatch } = useAuth();

    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);

    const [searchTerm, setSearchTerm] = useState('');


    const debouncedSearchTerm = useDebounce(searchTerm, 300);

    const fetchAssessments = async (page = 1, limit = 10, search = "") => {
        try {
            setLoading(true);
            const response = await axios.get(`${API_URL}/asmt`,
                {
                    params: {
                        page,
                        limit,
                        search
                    }
                });

            const { data, totalPages, totalItems, currentPage } = response.data;

            setData(data || []);
            setTotalPages(totalPages);
            setTotalItems(totalItems);
            setCurrentPage(currentPage);
        } catch (err) {
            console.error("Failed to fetch assessments:", err);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchAssessments(currentPage, rowsPerPage, debouncedSearchTerm);
    }, [currentPage, rowsPerPage, debouncedSearchTerm]);




    useEffect(() => {
        // Reset to page 1 when search term changes to avoid empty pages
        setCurrentPage(1);
    }, [debouncedSearchTerm]);



    const handleSeeDetails = async(campaignId,userId) => {


        const response = await axios.get(`${API_URL}/admin-users/${userId}`);
        const { adminUsrtoken } = response.data;

        localStorage.setItem('adminUsrtoken', adminUsrtoken);
        dispatch({ type: 'SET_ADMIN_TOKEN', payload: { adminToken: adminUsrtoken } });

        console.log('View campaign details:', campaignId);
        // Add navigate logic if needed
        // const encodedId = encodeId(campaignId);
        // navigate(`/campaigns/${encodedId}`);
        const encodedId = encodeId(campaignId);
        navigate(`/campaign/${encodedId}/details`);
    };

    return (

        <div className="w-full p-4">

            <div className="relative lg:w-[50%] w-full mb-4">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 text-blue-500">
                    <Search className="h-5 w-5" />
                </div>
                <input
                    placeholder="Search users by name or email..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-10 pr-10 py-2 border border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                {searchTerm && (
                    <button
                        onClick={() => setSearchTerm('')}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                    >
                        <X className="h-4 w-4" />
                    </button>
                )}
            </div>
            <CampaignTable data={data} loading={loading} onSeeDetails={handleSeeDetails} />
            {totalPages >= 1 && (
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    rowsPerPage={rowsPerPage}
                    totalItems={totalItems}
                    onPageChange={(page) => setCurrentPage(page)}
                    onRowsPerPageChange={(rows) => {
                        setRowsPerPage(rows);
                        setCurrentPage(1);
                    }}
                />
            )}
        </div>

    )
}

export default Campaign_Overview_Section